export const galleryUrl = 'https://museum.belegends.com/gallery'
